function updateObjectField(prev, address, value) {
    // eslint-disable-next-line no-useless-escape
    const currAddress = address && address.match(/^[^\.]+/)[0];
    const rest = address.slice(currAddress.length + 1);
    prev[currAddress] = rest ? {...prev[currAddress], ...updateObjectField(prev[currAddress], rest, value)} : value;
    return prev;
}

export default updateObjectField;
